<template>
    <div id="chatWindow">
        <VideoCallScreen :participants="participants" v-if="videoCallMode" />
        <div :class="{ opened: isOpen, closed: !isOpen }" class="sc-chat-window">
            <Header
                :colors="colors"
                :imageUrl="titleImageUrl"
                :participants="participants"
                :ticket-mode="ticketMode"
                :title="title"
                :headerTitle="this.headerTitle"
                @change-to-ticket="handleTicket"
                @deleteKVKK="() => (alertType = 'deleteKVKK')"
                @closeChat="() => (alertType = 'closeChat')"
            >
                <template>
                    <slot name="header"></slot>
                </template>
            </Header>
            <div v-if="pageIndex === 3 && alertType === null">
                <ChatHistoryListTwo
                    :colors="colors"
                    :message-styling="messageStyling"
                    :vuescrollOptions="vuescrollOptions"
                />
            </div>
            <div v-else-if="pageIndex === 4 && alertType === null">
                <SelectLanguage />
            </div>
            <div v-else-if="alertType">
                <Alert
                    :text="
                        alertType === 'deleteKVKK'
                            ? this.$t('visitorLanguage.deleteConversation')
                            : this.$t('visitorLanguage.endTheConversation')
                    "
                    style="color: var(--form-color-text)"
                    @ok="() => alertOkClickHandler()"
                    @cancel="() => (alertType = null)"
                />
            </div>
            <div v-else-if="showAfterActions && !reconnecting">
                <FeedBack
                    v-if="pageIndex === 5"
                    :agent="title"
                    :participants="participants"
                    :settings="settings"
                />
                <FeedBackResult v-else-if="pageIndex === 6" />
            </div>
            <div v-else>
                <!-- panel "Sohbet oncesi form" sekmesi: demo mesajlar yerine karsilama + form -->
                <div v-if="previewMode && previewView === 'precall'" class="messages-content">
                    <PrecallPanel preview :form-required="loginFormRequired" :greeting-html="triggerWelcomeHtml" />
                </div>
                <div v-else-if="previewMode && pageIndex === 1">
                    <MessageList
                        :alwaysScrollToBottom="true"
                        :colors="colors"
                        :messageStyling="messageStyling"
                        :messages="messages"
                        :participants="[{ _id: 1, name: 'John Doe' }]"
                        :showTypingIndicator="settings.agentTyping ? 'John Doe' : ''"
                        @remove="$emit('remove', $event)"
                        @scrollToTop="$emit('scrollToTop')"
                        :conversation-terminated="!connected"
                    >
                        <template v-slot:user-avatar="scopedProps">
                            <slot :message="scopedProps.message" :user="scopedProps.user" name="user-avatar"></slot>
                        </template>
                        <template v-slot:text-message-body="scopedProps">
                            <slot
                                :me="scopedProps.me"
                                :message="scopedProps.message"
                                :messageColors="scopedProps.messageColors"
                                :messageText="scopedProps.messageText"
                                name="text-message-body"
                            >
                            </slot>
                        </template>
                        <template v-slot:system-message-body="scopedProps">
                            <slot :message="scopedProps.message" name="system-message-body"></slot>
                        </template>
                        <template v-slot:text-message-toolbox="scopedProps">
                            <slot :me="scopedProps.me" :message="scopedProps.message" name="text-message-toolbox">
                            </slot>
                        </template>
                    </MessageList>
                    <UserInput
                        v-show="!ticketMode"
                        :colors="colors"
                        :onSubmit="() => {}"
                        :placeholder="placeholder"
                        :sendTyping="sendTyping"
                        :showEmoji="showEmoji"
                        :showFile="showFile"
                        @edit="$emit('edit', $event)"
                    />
                </div>
                <div v-else>
                    <div v-if="connectingSocket" id="connectingAlert" class="sps-status-chip is-info">
                        <span class="sps-status-spinner" aria-hidden="true"></span>
                        <span>{{ $t("message.connecting") }}</span>
                    </div>
                    <div v-if="isStartingChat" id="startingChatAlert" class="sps-status-chip is-info">
                        <span class="sps-status-spinner" aria-hidden="true"></span>
                        <span>{{ $t("message.welcomeStarting") }}</span>
                    </div>
                    <div v-if="reconnecting" id="reconnectionAlert" class="sps-status-chip is-error">
                        <span class="sps-status-dot" aria-hidden="true"></span>
                        <span>{{ $t("message.reconnecting") }}</span>
                    </div>
                    <div
                        v-show="settingsFetched"
                        id="messageContent"
                        ref="messagesContent"
                        class="messages-content"
                        :style="{
                            background: 'linear-gradient(0deg, var(--background-color-first), var(--background-color-second))',
                            color: 'white',
                        }"
                    >
                        <div v-if="!connected && !showAfterActions">
                            <OfflineSupportRequestForm
                                v-if="offlineMode || pageIndex === 2"
                                :ticket-mode="ticketMode"
                                @change-to-ticket="handleTicket"
                                @updateTitle="updateTitle"
                            />
                            <div v-else>
                                <!-- Tetikleyici karsilamasi varsa precall'in kendi selamlamasinin yerine gecer. -->
                                <PrecallPanel
                                    v-if="showPrecall"
                                    ref="precall"
                                    :form-required="loginFormRequired"
                                    :greeting-html="triggerWelcomeHtml"
                                    @open="openChatFromPrecall"
                                    @grow="onWelcomeCardGrow"
                                    @form-state="welcomeFormOpen = $event"
                                />
                            </div>
                        </div>
                        <div class="information-content">
<!--                            <div v-if="connected && loadMore" class="d-flex justify-content-center">-->
<!--                                <md-progress-spinner-->
<!--                                    v-observe-visibility="loadIt"-->
<!--                                    md-mode="indeterminate"-->
<!--                                    style="color: var(&#45;&#45;color7)"-->
<!--                                    class="loadMoreSpinner"-->
<!--                                />-->
<!--                            </div>-->
                            <div v-if="!loadedBefore && connected" class="d-flex justify-content-center">
                                <md-button @click="getChatHistory" style="text-transform: capitalize">
                                    {{ $t("message.chatHistory") }}
                                </md-button>
                            </div>
                            <MessageList
                                v-if="connected || showAfterActions || !offlineMode"
                                :alwaysScrollToBottom="alwaysScrollToBottom && !pauseScroll"
                                :colors="colors"
                                :messageStyling="messageStyling"
                                :messages="oldMessages.concat(messages)"
                                :onSubmit="onUserInputSubmit"
                                :participants="participants"
                                :scrollVS="$refs['vs']"
                                :showTypingIndicator="showTypingIndicator"
                                @remove="$emit('remove', $event)"
                                @mounted="() => scrollButtonClickHandler()"
                                :conversation-terminated="!connected"
                                :show-inline="showWelcomeCard"
                                :inline-at-start="welcomeCardAtStart"
                            >
                                <template v-slot:inline="_inline">
                                    <WelcomeCard
                                        v-if="showWelcomeCard"
                                        :key="cardKey"
                                        :initial-values="submittedFormValues"
                                        readonly
                                    />
                                </template>
                                <template v-slot:user-avatar="scopedProps">
                                    <slot :message="scopedProps.message" :user="scopedProps.user" name="user-avatar">
                                    </slot>
                                </template>
                                <template v-slot:text-message-body="scopedProps">
                                    <slot
                                        :me="scopedProps.me"
                                        :message="scopedProps.message"
                                        :messageColors="scopedProps.messageColors"
                                        :messageText="scopedProps.messageText"
                                        name="text-message-body"
                                    >
                                    </slot>
                                </template>
                                <template v-slot:system-message-body="scopedProps">
                                    <slot :message="scopedProps.message" name="system-message-body"></slot>
                                </template>
                                <template v-slot:text-message-toolbox="scopedProps">
                                    <slot
                                        :me="scopedProps.me"
                                        :message="scopedProps.message"
                                        name="text-message-toolbox"
                                    >
                                    </slot>
                                </template>
                            </MessageList>
                        </div>
                    </div>
                    <!-- Kaydirma kabinin DISINDA: icinde olunca icerikle birlikte
                         kayiyor ve yukari cikinca alanin ortasinda beliriyordu. -->
                    <div
                        class="scroll-button"
                        :style="{
                            bottom: isRepTyping
                                ? 'calc(var(--sps-input-h, 70px) + 46px)'
                                : 'calc(var(--sps-input-h, 70px) + 12px)',
                        }"
                        v-if="(isExistNewMessage || isScrolledUp) && !offlineMode && connected"
                    >
                        <div class="scroll-button-container">
                            <EllipsIconButton
                                iconName="ArrowB"
                                bgColor="var(--primary_)"
                                @btnClicked="() => scrollButtonClickHandler()"
                                padding="18px"
                            />
                        </div>
                    </div>

                    <TypingMessage v-show="isRepTyping" :messageColors="{}" />

                    <div v-if="pageIndex !== 2 && !showAfterActions">
                        <UserInput
                            v-if="isUserInputVisible()"
                            :colors="colors"
                            :onSubmit="handleComposerSubmit"
                            :placeholder="composerPlaceholder"
                            :sendTyping="sendTyping"
                            :showEmoji="showEmoji"
                            :showFile="showFile"
                            @edit="$emit('edit', $event)"
                            :chatbot-active="chatbotActive"
                            :prechat="composerPrechat"
                            @locked-attempt="onComposerLocked"
                            @pressEnter="scrollButtonClickHandler"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computeLoginFormRequired } from "@/utils/loginFormRequired";
import Header from "./../popup-chat/Header.vue";
import MessageList from "./MessageList.vue";
import UserInput from "./UserInput.vue";
import UserList from "./UserList.vue";
import PrecallPanel from "../PrecallPanel.vue";
import * as openingGate from "../../../utils/openingMessageGate";
import { resolveChatText } from "../../../utils/chatTexts";
import WelcomeCard from "../WelcomeCard.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import AfterActions from "../AfterActions";
import { log2 } from "../../../utils/log2";
import * as _ from "lodash";
import Rate2 from "../Rate2";
import { sendTranscript } from "../../../api/chat";
import OfflineSupportRequestForm from "../OfflineSupportRequestForm";
import { sessionId } from "../../../utils/session";
import { getVisitorToken, VISITOR_TOKEN_SUPPORTED } from "../../../utils/visitorToken";
import version from "../../../utils/version";
import { sendSocketMessage, socketMessageStream } from "../../../utils/socketStream";
import { bufferTime, filter } from "rxjs/operators";
import TypingMessage from "./messages/TypingMessage";
import VideoCallScreen from "../VideoCallScreen.vue";
import ChatHistoryList from "../ChatHistoryList";
import ChatHistoryListTwo from "../ChatHistoryListTwo.vue";
import {
    chatBaloonIsOpened,
    parentWindowMessageStream,
    sendCommandToParentWindow,
} from "../../../utils/parentWindowConnection";
import { deletePersonalData, fetchChatHistory } from "../../../api/visitor";
import request from "../../../utils/request";
import DateUtils from "../../../utils/DateUtil";
import SelectLanguage from "../SelectLanguage.vue";
import Alert from "../Alert.vue";
import { publishMessage, SystemMessageTypes } from "../../../utils/systemPubSub";
import { playIncoming, playOutgoing } from "../../../utils/sounds";
import FeedBack from "../FeedBack.vue";
import { isChatRated, isRatingSuppressed } from "../../../utils/ratedChats";
import FeedBackResult from "../FeedBackResult.vue";
import EllipsIconButton from "../../../common/IconButton.vue";
import { CONFIG } from "../../../utils/config";
import { autoScrollDisabled } from "../../../utils/autoScrollGuard";

const log = log2("ChatWindow");

export default {
    components: {
        ChatHistoryList,
        FeedBack,
        FeedBackResult,
        ChatHistoryListTwo,
        VideoCallScreen,
        Header,
        MessageList,
        UserInput,
        UserList,
        PrecallPanel,
        WelcomeCard,
        OfflineSupportRequestForm,
        AfterActions,
        Rate2,
        TypingMessage,
        SelectLanguage,
        Alert,
        EllipsIconButton,
    },
    props: {
        sendTyping: {
            type: Function,
            default: () => {},
        },
        showEmoji: {
            type: Boolean,
            default: false,
        },
        showCloseButton: {
            type: Boolean,
            default: true,
        },
        showFile: {
            type: Boolean,
            default: false,
        },
        participants: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            required: true,
        },
        titleImageUrl: {
            type: String,
            default: "",
        },
        onUserInputSubmit: {
            type: Function,
            required: true,
        },
        onClose: {
            type: Function,
            required: true,
        },
        messageList: {
            type: Array,
            default: () => [],
        },
        isOpen: {
            type: Boolean,
            default: () => false,
        },
        placeholder: {
            type: String,
            default: "Write a message...",
        },
        showTypingIndicator: {
            type: String,
            required: true,
        },
        colors: {
            type: Object,
            required: true,
        },
        alwaysScrollToBottom: {
            type: Boolean,
            required: true,
        },
        messageStyling: {
            type: Boolean,
            required: true,
        },
        chatbotActive: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            headerColorFirst: "#EC4B1D",
            headerColorSecond: "#EC4B1D",
            backgroundColorFirst: "#FFFFFF",
            backgroundColorSecond: "#FFFFFF",
            loading: false,
            transcriptIsSent: false,
            isRepTyping: false,
            repTypingTracker: undefined,
            repTypingEndTracker: undefined,
            isExistNewMessage: false,
            isScrolledUp: false,
            contentResizeObserver: null,
            chromeResizeObserver: null,
            chromeObserved: false,
            startingChat: false,
            submittedFormValues: null,
            welcomeCardAtStart: false,
            queuedMessages: [],
            welcomeAnchorCount: 0,
            // Precall karsilama formu ekranda mi: cubuk kilidi buna bagli.
            welcomeFormOpen: false,
            scrollPosition: null,
            vuescrollOptions: {
                vuescroll: {
                    mode: "native",
                    sizeStrategy: "percent",
                    detectResize: true,
                },
                scrollPanel: {
                    initialScrollY: false,
                    initialScrollX: false,
                    scrollingX: false,
                    scrollingY: true,
                    speed: 300,
                    easing: undefined,
                    verticalNativeBarPos: "right",
                },
                rail: {
                    size: "7px",
                    background: "#fff",
                    opacity: 0.3,
                },
                bar: {
                    size: "7px",
                    background: "#fff",
                    opacity: 0.6,
                },
            },
            ticketMode: false,
            updateLanguage: false,
            alertType: null,
            page: 1,
            loadMore: false,
            pauseScroll: true,
            loadedBefore: false,
            oldMessages: [],
            headerTitle: "",
            scrollButton: false,
            CONFIG,
        };
    },
    computed: {
        ...mapState({
            visitingPage: (state) => state.app.visitingPage,
            pageIndex: (state) => state.app.pageIndex,
            settings: (state) => state.setting.settings,
            connected: (state) => state.chat.connected,
            site: (state) => state.site.site,
            showAfterActions: (state) => state.app.showAfterActions,
            visitorId: (state) => state.chat.visitorId,
            chatAgents: (state) => state.chat.chatAgents,
            conversationId: (state) => state.chat.lastConversationId,
            // Kartin sifirlanmasi icin canli konusma kimligi ayrica lazim.
            liveConversationId: (state) => state.chat.conversationId,
            mobileVersion: (state) => state.app.mobileVersion,
            offlineMode: (state) => state.setting.offlineMode,
            volume: (state) => state.app.volume,
            videoCallMode: (state) => state.app.videoCallMode,
            previewMode: (state) => state.app.previewMode,
            // panel hangi ekrani onizlettiyse (DemoVisitor view): "precall" = sohbet oncesi form
            previewView: (state) => _.get(state.setting.previewDraft, "__previewView", ""),
            settingsFetched: (state) => state.setting.fetched,
            loginFormRequired: (state) => computeLoginFormRequired(state),
            connectionLost: (state) => state.chat.connectionLost,
            visitorInteracted: (state) => state.app.visitorInteracted,
        }),
        // App.getMessages karsilamayi listenin basina koyar; precall selamlamasi olarak cizilir,
        // konusma baslayinca resetState ile silinir (varsayilan selamlama gibi).
        triggerWelcomeMessage() {
            return (this.messageList || []).find((m) => m.raw && m.raw.isTriggerWelcome) || null;
        },
        triggerWelcomeHtml() {
            return this.triggerWelcomeMessage ? this.triggerWelcomeMessage.data.text || "" : "";
        },
        ...mapGetters({
            reconnecting: "chat/reconnecting",
            connectingSocket: "chat/connectingSocket",
            settings: "setting/getSetting",
        }),
        messages() {
            // Form gonderilir gonderilmez bekleyen mesaj listeye ekleniyor ama
            // precall paneli hala ekranda ve listenin USTUNDE duruyor: balon
            // formun altina dusuyor, baglanti kurulunca tekrar ustune ciciyor.
            // Devir bitene kadar listede gosterilmiyor (panel zaten kendi
            // tamponlanan kopyasini ciziyor).
            if (this.isStartingChat && this.showPrecall) return [];
            let messages = this.messageList;
            // Precall acikken karsilama panelde selamlama olarak duruyor; listede ikinci kez cizilmesin.
            if (this.showPrecall) messages = messages.filter((m) => !(m.raw && m.raw.isTriggerWelcome));
            if (!this.loginFormRequired && !this.ticketMode) {
                return [...messages];
            }
            return messages;
        },
        isAnyUserConnected() {
            return !this.chatAgents.some((x) => x._id === "chatbot");
        },
        // Sohbet henuz acilmadi ve karsilama isteniyor: ilk mesaj sohbeti baslatir.
        isPrecall() {
            return this.loginFormRequired && !this.connected && !this.offlineMode && !this.showAfterActions;
        },
        // Sohbet acilmadan once CTA/form ekrani. Form yoksa da gosteriliyor:
        // CTA ile tek tikla baslamak form olmayan sitede de gerekli.
        showPrecall() {
            return !this.connected && !this.offlineMode && !this.showAfterActions && !this.ticketMode;
        },
        // Sohbet acildiktan sonra doldurulmus form salt-okunur olarak akista
        // kaliyor; degerler precall'dan tasiniyor.
        showWelcomeCard() {
            return this.connected && !!this.submittedFormValues;
        },
        composerPlaceholder() {
            // panelden yazilan mesaj kutusu metni sohbet baslamadan once de gecerli
            return this.isPrecall ? resolveChatText(this.settings, "placeholder", this.$i18n.locale, this.$t("message.welcomePrecallHint")) : this.placeholder;
        },
        // Karsilama formu acikken cubuk kilitli: ziyaretci mesaj yazip
        // cevap bekliyor, oysa sohbet form gonderilmeden acilmiyor.
        composerPrechat() {
            const kilitli = this.showPrecall && this.welcomeFormOpen;
            return {
                enabled: kilitli,
                locked: kilitli,
                placeholder: kilitli ? this.$t("message.welcomeComposerLocked") : "",
                prefill: "",
            };
        },
        hasWelcomeAnchor() {
            return this.welcomeAnchorCount > 0;
        },
        cardKey() {
            return (this.liveConversationId || "welcome") + ":" + this.welcomeAnchorCount;
        },
        // CTA'ya basildiktan sonra sohbet acilana kadar ziyaretci bosluga
        // bakiyordu; bu sirada durum cipi gosteriliyor.
        isStartingChat() {
            return this.startingChat && !this.connected;
        },
        chatSoundEnabled() {
            return _.get(this.settings, "webchat.notifications.sound", true);
        },
    },
    methods: {
        ...mapActions({
            toggleCloseChatConfirmation: "app/toggleCloseChatConfirmation",
            toggleAfterActions: "app/toggleAfterActions",
            disconnectChat: "chat/disconnect",
            resetConversation: "chat/resetConversation",
            toggleRating: "app/toggleRating",
            setVisitorIsLoggedIn: "chat/setVisitorIsLoggedIn",
            setVisitorIsLogging: "chat/setVisitorIsLogging",
            getSettings: "setting/getSettings",
        }),
        ...mapMutations({
            changePageIndex: "app/CHANGE_PAGE",
        }),
        getColors() {
            // Tema yapisi eksik gelen sitede bu satir mounted'i cokertiyordu
            // (Cannot read properties of undefined). Zincir korumali okunuyor.
            const colors = _.get(this.settings, "chatCustomizationSettings.versionV2Theme.colors") || {};
            this.backgroundColorFirst = colors.backgroundColorFirst || "#ffffff";
            this.backgroundColorSecond = colors.backgroundColorSecond || "#ffffff";
            //document.documentElement.style.setProperty("--demoBackgroundForBefore", colors.backgroundColorFirst);
        },
        isUserInputVisible() {
            const isConnected = this.connected && !this.reconnecting;
            if (this.ticketMode) return false;
            // Karsilama diyalogu cevaplari cubuktan aliyor: form asamasinda da acik.
            if (this.loginFormRequired && !this.offlineMode && !this.showAfterActions) return true;
            return isConnected || (!this.loginFormRequired && !this.offlineMode);
        },
        listenMessageContentScroll() {
            this.$refs.messagesContent.addEventListener("scroll", () => {
                this.isScrolledUp = !this.isNearBottom(20);
                if (!this.isScrolledUp) this.isExistNewMessage = false;
            });
        },
        // Kutunun dibine ne kadar yakiniz? Otomatik kaydirma bu esige gore karar veriyor.
        isNearBottom(threshold = 150) {
            const el = this.$refs.messagesContent;
            if (!el) return true;
            return el.scrollHeight - el.scrollTop - el.clientHeight <= threshold;
        },
        // Once DOM'un basilmasini, sonra bir kareyi bekler; sabit gecikmeyle
        // kaydirmak mesaj daha ekrana gelmeden calisip yariyolda birakiyordu.
        // Kart belirip buyudukce dibe in. Ama kullanici formda yukari cikip
        // bir alani duzeltiyorsa asagi cekmiyoruz; yalnizca zaten dipteyse.
        onComposerLocked() {
            if (this.$refs.precall) this.$refs.precall.shakeForm();
        },
        onWelcomeCardGrow(reason) {
            // Katlanmis kart acilirken kaydirmiyoruz: alanlar asagi dogru
            // ekleniyor, ust kenar yerinde kaliyor. Dibe cekmek ziyaretcinin
            // yeni tikladigi ilk alani ekranin ustunden disari itiyordu.
            if (reason === "expand") return;
            const el = this.$refs.messagesContent;
            const dipteMi = !el || el.scrollHeight - el.scrollTop - el.clientHeight <= 200;
            if (!dipteMi) return;
            this.isScrolledUp = false;
            this.scrollToBottom(true);
        },
        scrollToBottom(smooth = false) {
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    const el = this.$refs.messagesContent;
                    if (!el) return;
                    // Karsilama formu ekrandayken kaydirma yok.
                    if (autoScrollDisabled()) return;
                    if (smooth && typeof el.scrollTo === "function") {
                        el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
                    } else {
                        el.scrollTop = el.scrollHeight;
                    }
                    this.isScrolledUp = false;
                });
            });
        },
        // Gorsel/dosya mesajlari yuklendikce yukseklik degisiyor; dipteysek dipte kal.
        observeContentResize() {
            const el = this.$refs.messagesContent;
            if (!el || typeof ResizeObserver === "undefined") return;
            const list = el.querySelector("#sc-message-list") || el.firstElementChild;
            if (!list) return;
            this.contentResizeObserver = new ResizeObserver(() => {
                if (autoScrollDisabled()) return;
                if (!this.isScrolledUp) {
                    el.scrollTop = el.scrollHeight;
                }
            });
            this.contentResizeObserver.observe(list);
        },
        // Mobilde klavye acilinca 100vh kucul­muyor ve yazma alani klavyenin altinda
        // kaliyordu. Gorunur alanin gercek yuksekligini degiskene yaziyoruz.
        applyViewportHeight() {
            const vv = window.visualViewport;
            const height = vv ? vv.height : window.innerHeight;
            document.documentElement.style.setProperty("--app-vh", height + "px");
            this.applyChromeHeights();
            // Mobilde klavye acilinca burasi tetikleniyor. Ziyaretci karsilama
            // formunu dolduruyorsa dibe cekmiyoruz: odaktaki alan ekrandan
            // cikiyordu, tarayici zaten odagi gorunur alana getiriyor.
            if (!this.isScrolledUp && !this.isEditingWelcomeForm()) this.scrollToBottom();
        },
        // Odak karsilama formunun icinde mi? Otomatik kaydirmalar buna bakiyor.
        isEditingWelcomeForm() {
            const active = document.activeElement;
            return !!(active && active.closest && active.closest("#welcome-card"));
        },
        // Baslik ve yazma cubugu sabit degil: cubuk cok satirda buyuyor, baslikta
        // avatar olup olmamasi yuksekligi degistiriyor. Mesaj alani ve yazma
        // gostergesi bu iki olcuye dayansin ki hicbiri cubugun altinda kalmasin.
        applyChromeHeights() {
            const root = document.documentElement;
            const header = document.getElementById("chatHeader");
            const input = document.getElementById("userInputMain");
            if (header) root.style.setProperty("--sps-header-h", header.offsetHeight + "px");
            if (input) root.style.setProperty("--sps-input-h", input.offsetHeight + "px");
        },
        // Yazma cubugu sohbet baglanmadan once DOM'da olmayabiliyor; ikisi de
        // baglanana kadar her guncellemede yeniden deneniyor.
        observeChromeResize() {
            if (typeof ResizeObserver === "undefined" || this.chromeObserved) return;
            const targets = [document.getElementById("chatHeader"), document.getElementById("userInputMain")];
            if (!targets.some(Boolean)) return;
            if (!this.chromeResizeObserver) {
                this.chromeResizeObserver = new ResizeObserver(() => this.applyChromeHeights());
            }
            targets.filter(Boolean).forEach((el) => this.chromeResizeObserver.observe(el));
            this.chromeObserved = targets.every(Boolean);
            this.applyChromeHeights();
        },
        // Sohbet form gonderilince aciliyor. Boylece subjectId, ozel form
        // cevaplari ve kisi verisi "visitor login" cagrisinda hazir oluyor;
        // atama algoritmasi ve chatbot attribute'lari bunlara bakiyor.
        openChatFromPrecall({ initialMessage, extraMessages, loginData, values }) {
            this.startingChat = true;
            // Doldurulmus degerler saklaniyor: sohbet acilinca kart salt-okunur
            // "gonderildi" halinde akista yeniden ciziliyor.
            if (values) this.submittedFormValues = values;
            this.welcomeCardAtStart = !initialMessage;
            this.queuedMessages = extraMessages || [];
            publishMessage(SystemMessageTypes.AUTO_LOGIN, { initialMessage, loginData });
        },
        // Precall'da birden fazla mesaj yazildiysa ilki login ile gidiyor,
        // kalanlar baglanti kurulunca sirayla yollaniyor.
        flushQueuedMessages() {
            if (!this.queuedMessages.length) return;
            const rest = this.queuedMessages;
            this.queuedMessages = [];
            const send = () => rest.forEach((text) => this.onUserInputSubmit(text));
            // AI karsilamasi bekleniyorsa ilk mesajdan sonra sirayla gitsin
            if (openingGate.isArmed()) openingGate.wait().then(send);
            else send();
        },
        handleComposerSubmit(payload) {
            // Precall sirasinda mesaj sunucuya gitmiyor: precall tamponuna
            // yaziliyor, sohbet form gonderilince aciliyor.
            if (this.showPrecall && typeof payload === "string" && this.$refs.precall) {
                return this.$refs.precall.start(payload);
            }
            // WhatsApp gibi: gonderirken de ses var, gelenden farkli tonda.
            playOutgoing({ volume: this.volume, enabled: this.chatSoundEnabled });
            return this.onUserInputSubmit(payload);
        },
        scrollButtonClickHandler() {
            this.isExistNewMessage = false;
            this.scrollToBottom(true);
        },
        alertOkClickHandler() {
            if (this.alertType === "closeChat") {
                this.changePageIndex(5);
                this.onClose();
                this.alertType = null;
            }
            if (this.site && this.visitorId && this.alertType === "deleteKVKK") {
                deletePersonalData(this.site._id, this.visitorId).then((isDeleted) => {
                    if (isDeleted.status == 200) {
                        this.alertType = null;
                        publishMessage(SystemMessageTypes.PERSONAL_DATA_DELETED, {});
                    }
                });
            }
        },
        connect() {
            sendSocketMessage("visitor connect", {
                visitorId: this.visitorId,
                visitorToken: getVisitorToken(),
                tokenSupported: VISITOR_TOKEN_SUPPORTED,
                conversationId: this.conversationId,
                siteId: this.site._id,
                sessionId,
                version,
            });
        },
        reconnect() {
            this.toggleRating(false);
            this.toggleAfterActions(false);
            this.resetConversation();
            this.setVisitorIsLoggedIn(false);
            this.setVisitorIsLogging(false);
            this.connect();
            this.transcriptIsSent = false;
        },
        startSendTranscript() {
            log("startSendTranscript başladı");
            this.loading = true;
            sendTranscript(this.conversationId)
                .then((x) => {
                    this.transcriptIsSent = true;
                    (this.loading = false), log("respons başarılı");
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
        },
        handleTicket(val) {
            this.ticketMode = val;
            log("event is here ", { val });
        },
        loadIt: _.debounce(function (e) {
            if (e && this.loadMore) {
                this.getChatHistory();
            }
        }, 500),
        getChatHistory() {
            fetchChatHistory(this.site._id, this.visitorId, this.page, 1)
                .then((res) => {
                    log("fetchChatHistory", res.data);
                    const { conversations, totalCount, currentPage, pageSize } = res.data;
                    if (!!conversations.length)
                        this.loadHistoryMessages(
                            conversations[0]._id,
                            DateUtils.formatDateTime(conversations[0].createdDate, this.$i18n.locale),
                        );
                    this.loadMore = totalCount > currentPage;
                })
                .finally(() => {
                    this.page++;
                    this.loadedBefore = true;
                });
        },
        loadHistoryMessages(chatId, date) {
            const convertMessages = (items) => {
                const allMessages = items
                    .map((x, i) => {
                        let type = "";
                        let author = "";
                        if (x.messageType === "system") {
                            type = "system";
                        } else if (["user", "chatbot"].includes(x.messageType)) {
                            type = "text";
                            author = x.userId || "chatbot";
                        } else if (x.messageType === "private") {
                            type = "private";
                        } else if (x.messageType === "visitor") {
                            type = "text";
                            author = "me";
                        } else if (x.messageType === "user-media" || x.messageType === "visitor-media") {
                            author = x.messageType === "user-media" ? x.userId : "me";
                            if (x.asset.mime.includes("image")) {
                                type = "image";
                            } else if (x.asset.mime.includes("audio")) {
                                type = "audio";
                            } else {
                                type = "asset";
                            }
                        }
                        return {
                            type,
                            author,
                            data: {
                                text: x.message || x.description,
                                textTranslated: x.translatedMessage,
                                meta: DateUtils.formatHour(x.createdDate),
                            },
                            raw: x,
                        };
                    })
                    .filter((x) => x !== undefined);
                allMessages.push({
                    author: "",
                    type: "divider",
                    date,
                    raw: { _id: null },
                });
                log("allMessages", allMessages);
                return allMessages;
            };
            if (chatId) {
                return request({
                    url: `/conversations/${chatId}/messages`,
                    method: "get",
                }).then((response) => {
                    let items = response.data.data;
                    items = _.orderBy(
                        _.uniqBy(items, (q) => q.uniqMessageId || q._id),
                        (q) => new Date(q.createdDate).getTime(),
                        "asc"
                    );
                    let unReadElement = document.getElementById(
                        "sc-message_" + _.get(this.oldMessages, "[0].raw._id", 0)
                    );
                    this.oldMessages = convertMessages(items).concat(this.oldMessages);
                    this.pauseScroll = true;
                    if (!!unReadElement) unReadElement.scrollIntoView();
                });
            }
        },
        updateTitle(newTitle) {
            this.headerTitle = newTitle;
        },
    },
    async created() {
        log("ChatWindow created");
    },
    mounted() {
        // Eski kod buraya satir ici "yukseklik = %92" yaziyordu; basligi ve yazma
        // cubugunu saymadigi icin son mesaj cubugun altinda kaliyordu. Yukseklik
        // artik stil dosyasinda olculen baslik/cubuk yuksekligine dayaniyor.
        this.applyViewportHeight();
        if (window.visualViewport) {
            window.visualViewport.addEventListener("resize", this.applyViewportHeight);
            window.visualViewport.addEventListener("scroll", this.applyViewportHeight);
        }
        log("mounted", { connecting: this.connecting, reconnecting: this.reconnecting });
        chatBaloonIsOpened(() => {
            this.scrollButtonClickHandler();
        });
        this.listenMessageContentScroll();
        this.observeContentResize();
        this.observeChromeResize();

        // Widget yeniden acildiginda son mesaja inilmiyordu: ChatWindow
        // "iframe-open" olayini hic dinlemiyordu, MessageList'in kendi
        // _scrollDown'i da vuescroll bekledigi icin oluydu.
        this.openScrollSub = parentWindowMessageStream
            .pipe(filter((x) => ["iframe-open", "maximize"].includes(x.command)))
            .subscribe(() => {
                this.isScrolledUp = false;
                this.scrollToBottom();
                // Yukseklikler acilista yerlesiyor: bir kare sonra tekrar.
                setTimeout(() => {
                    this.isScrolledUp = false;
                    this.scrollToBottom();
                }, 250);
            });

        // Eskiden yalniz messageType === "user" dinleniyordu: chatbot, e-posta ve
        // SMS mesajlarinda ne ses caliyordu ne de sekme rozeti gidiyordu.
        const isIncomingMessage = (data) => {
            const type = String((data && data.messageType) || "");
            if (!type || type === "visitor" || type === "system") return false;
            if (String((data && data.type) || "") === "rep-typing") return false;
            return true;
        };

        socketMessageStream
            .pipe(filter((x) => x.cmd === "message" && isIncomingMessage(x.data)))
            .subscribe(() => {
                // Panelden "Sesli uyari" kapatilabiliyor.
                if (this.visitorInteracted) {
                    playIncoming({ volume: this.volume, enabled: this.chatSoundEnabled });
                }
                sendCommandToParentWindow("badge");
            });
        this.repTypingTracker = socketMessageStream.subscribe(
            ({ cmd, data }) => {
                if (cmd === "message") {
                    const type = data.type || data.messageType || "";
                    log("repTypingTracker", { cmd, data, type });
                    if (type === "rep-typing") {
                        this.isRepTyping = true;
                        if (this.repTypingEndTrackerTimerId) clearTimeout(this.repTypingEndTrackerTimerId);
                        this.repTypingEndTrackerTimerId = setTimeout(() => {
                            if (this.isRepTyping) this.isRepTyping = false;
                        }, 2000);
                    } else if (type === "user-message" || type.includes("chatbot")) {
                        this.isRepTyping = false;
                    }
                }
            },
            (err) => {
                log.error("repTypingTracker error", err);
            }
        );

        this.repTypingEndTracker = socketMessageStream
            .pipe(
                filter((x) => x.cmd === "message" && x.data.type === "rep-typing"),
                bufferTime(2000),
                filter((xs) => xs.length === 0)
            )
            .subscribe(
                (x) => {
                    this.isRepTyping = false;
                },
                (error) => {
                    console.error("sub error", error);
                }
            );
        this.getColors();
    },
    updated() {
        log("updated", {
            connecting: this.connecting,
            reconnecting: this.reconnecting,
            afterAction: this.showAfterActions,
        });
        this.observeChromeResize();
    },
    beforeDestroy() {
        if (this.openScrollSub) this.openScrollSub.unsubscribe();
        this.repTypingTracker.unsubscribe();
        this.repTypingEndTracker.unsubscribe();
        if (this.repTypingEndTrackerTimerId) clearTimeout(this.repTypingEndTrackerTimerId);
        if (window.visualViewport) {
            window.visualViewport.removeEventListener("resize", this.applyViewportHeight);
            window.visualViewport.removeEventListener("scroll", this.applyViewportHeight);
        }
        if (this.contentResizeObserver) this.contentResizeObserver.disconnect();
        if (this.chromeResizeObserver) this.chromeResizeObserver.disconnect();
    },
    watch: {
        // Kart cizildigi anda var olan mesaj SAYISI donduruluyor: o ana kadarki
        // mesajlar kartin ustunde, sonrakiler altinda kaliyor. Id ile takip
        // denendi ve basarisiz oldu (bekleyen mesaj sunucu id'siyle degisiyor).
        showWelcomeCard: {
            immediate: true,
            handler(visible) {
                if (!visible) {
                    this.welcomeAnchorCount = 0;
                    return;
                }
                if (this.welcomeAnchorCount > 0) return;
                const count = this.oldMessages.concat(this.messages).length;
                if (count > 0) this.welcomeAnchorCount = count;
            },
        },
        // Kart mesajsiz acildiysa ilk mesaj gelince cipalaniyor.
        messages() {
            if (!this.showWelcomeCard || this.welcomeAnchorCount > 0) return;
            const count = this.oldMessages.concat(this.messages).length;
            if (count > 0) this.welcomeAnchorCount = count;
        },
        windowWidth() {
            this.applyChromeHeights();
        },
        connected(nVal, oVal) {
            if (nVal === true) {
                this.startingChat = false;
                this.$nextTick(() => this.flushQueuedMessages());
            }
            if (nVal === false && nVal !== oVal) {
                this.loadedBefore = false;
                this.loadMore = false;
                this.page = 1;
                this.oldMessages = [];
                if (this.alertType === "closeChat") {
                    /*In case the connection is terminated, the customer representative voting screen opens.*/
                    this.changePageIndex(5);
                    this.onClose();
                    this.alertType = null;
                }
            }
        },
        alertType() {
            if (this.alertType) {
                this.updateLanguage = false;
            }
        },
        pageIndex() {},
        showAfterActions() {
            // Bu konusma zaten puanlandiysa (ya da atlandiysa) degerlendirme ekranini
            // tekrar acma; watcher her showAfterActions degisiminde 5'e itiyordu.
            if (this.showAfterActions && !this.reconnecting && this.pageIndex != 5) {
                // conversationId yokken puanlanacak konusma yok ("Atla"
                // resetConversation cagirdigi icin id null kaliyor ve
                // isChatRated(null) hep false donuyordu); atla sonrasi
                // sunucunun verdigi yeni id de ratedIds'de bulunmuyor.
                const puanlanmaz =
                    !this.conversationId || isRatingSuppressed() || isChatRated(this.conversationId);
                if (puanlanmaz) {
                    // Ekrani acmiyorsak bayragi da dusurmeliyiz: sablonda
                    // showAfterActions dali aciliyor ama icindeki iki kosul da
                    // tutmadigi icin bos beyaz ekran kaliyordu.
                    this.toggleAfterActions(false);
                    // Sohbet bitti: eski mesajlar ekranda kalmamali. Puanlama
                    // gosterildiginde Rate2.reconnect bunu zaten yayinliyor,
                    // atlandiginda kimse yayinlamiyordu ve ziyaretci ayni
                    // konusmanin uzerine dusuyordu.
                    publishMessage(SystemMessageTypes.RESTART_NEEDED, {});
                    return;
                }
                this.changePageIndex(5);
            }
        },
        messageList: {
            handler: function (next, prev) {
                const lastMessage = this.messageList.slice(-1)[0];
                if (lastMessage && this.$refs.messagesContent) {
                    const isMine = lastMessage.author === "me";
                    // Kendi mesajim her zaman dibe cekilir; karsi tarafinki yalnizca
                    // ben zaten dipteysem. Yukaridaysam "yeni mesaj" butonu cikar.
                    if (isMine || this.isNearBottom()) {
                        this.isExistNewMessage = false;
                        this.scrollToBottom();
                    } else {
                        this.isExistNewMessage = true;
                    }
                }
            },
            immediate: true,
        },
        settings() {
            this.getColors();
        },
    },
};
</script>

<style lang="scss" scoped>
#chatWindow {
    position: relative;
    /* Mobilde klavye acilinca 100vh kucul­muyor; --app-vh gorunur alani tasiyor. */
    height: var(--app-vh, 100vh);
    // cerceveyle ayni renk: yuvarlak pencerenin disinda kalan koseler ayri renk gibi gorunmesin
    background: var(--header-color-second) !important;
}

.sc-chat-window {
    width: 100%;
    height: calc(var(--app-vh, 100vh) - 40px);
    box-sizing: border-box;
    // mesaj alaniyla ayni gecis: onizleme (mesaj alani olmadan cizilir) ve bos alanlar gercek sohbetle ayni gorunsun
    background: linear-gradient(0deg, var(--background-color-first), var(--background-color-second));
    color: var(--header-text-color) !important;
    display: flex;
    flex-direction: column;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    animation: fadeIn;
    animation-duration: 0.3s;
    animation-timing-function: ease-in-out;
    position: relative;
    border: 3px solid var(--header-color-second);
    border-radius: var(--sps-widget-radius) !important;
}

.messages-content {
    padding-bottom: 30px !important;
}

.sc-chat-window.closed {
    opacity: 0;
    display: none;
    bottom: 90px;
}

.scroll-button {
    position: absolute;
    bottom: calc(var(--sps-input-h, 70px) + 12px);
    // Sagda: solda tam genislikteki karsilama kartinin etiketlerini kapatiyordu.
    right: 15px;
}

@keyframes fadeIn {
    0% {
        display: none;
        opacity: 0;
    }

    100% {
        display: flex;
        opacity: 1;
    }
}

.sc-message--me {
    text-align: right;
}

.sc-message--them {
    text-align: left;
}

@media (max-width: 450px) {
    .sc-chat-window {
        width: 100%;
        height: 100%;
        max-height: 100%;
        right: 0px;
        bottom: 0px;
        border-radius: 0px;
    }

    .sc-chat-window {
        transition: 0.1s ease-in-out;
    }

    .sc-chat-window.closed {
        bottom: 0px;
    }
}

// Bagalanti durumu: tam genislikte doygun serit yerine ustte yuzen cip.
.sps-status-chip {
    // Mutlak konumda dayanak eleman bu ekranda 0 genislige dusuyordu; goruntu
    // alanina sabitlemek olcuyu her durumda dogru veriyor.
    position: fixed;
    top: 74px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    // left:50% ile konumlanan fixed kutuda shrink-to-fit icin kullanilabilir
    // genislik ekranin YARISI kadar: cip daralip yaziyi uzun bir sutuna
    // doviyordu. max-content once tek satirlik genisligi istiyor, max-width
    // onu ekrana sigdiriyor; kisa mesajlarda hap yine kompakt kaliyor.
    width: -webkit-max-content;
    width: max-content;
    max-width: calc(100% - 32px);
    height: auto;
    padding: 8px 14px;
    border-radius: var(--sps-radius-pill, 999px);
    font-size: 13px;
    font-weight: 500;
    line-height: 1.3;
    // Uzun uyari metni ("Sunucu ile baglantiniz koptu, yeniden baglaniliyor")
    // tek satira sigmiyordu. nowrap + text-overflow ellipsis burada ise
    // yaramiyor: metin flex ogesi olan span'in icinde, ellipsis flex ogesine
    // uygulanmiyor ve yazi ucundan kirpiliyordu. Metin artik satir kiriyor.
    white-space: normal;
    text-align: center;
    overflow-wrap: break-word;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12), 0 1px 2px rgba(15, 23, 42, 0.06);
    animation: sps-status-in 200ms cubic-bezier(0.16, 1, 0.3, 1);

    span {
        margin: 0;
        // Flex ogesinin varsayilan min-width:auto degeri metnin daralmasini
        // engelliyordu; satir kirilmasi bu olmadan calismiyor.
        min-width: 0;
    }

    &.is-info {
        background-color: #ffffff;
        border: 1px solid rgba(15, 23, 42, 0.1);
        color: var(--primary-text, #1f2937);
    }

    &.is-error {
        background-color: #fef3f2;
        border: 1px solid #fecdca;
        color: #b42318;
    }
}

.sps-status-spinner {
    flex-shrink: 0;
    width: 13px;
    height: 13px;
    border: 2px solid rgba(15, 23, 42, 0.15);
    border-top-color: var(--button-color);
    border-radius: 50%;
    animation: sps-status-spin 700ms linear infinite;
}

.sps-status-dot {
    flex-shrink: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #d92d20;
    animation: sps-status-pulse 1.4s ease-in-out infinite;
}

@keyframes sps-status-in {
    from {
        opacity: 0;
        transform: translateX(-50%) translateY(-8px);
    }
    to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }
}

@keyframes sps-status-spin {
    to {
        transform: rotate(360deg);
    }
}

@keyframes sps-status-pulse {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.35;
    }
}

@media (prefers-reduced-motion: reduce) {
    .sps-status-chip,
    .sps-status-spinner,
    .sps-status-dot {
        animation: none !important;
    }
}

</style>
<style lang="scss">
.loadMoreSpinner {
    .md-progress-spinner-circle {
        stroke: var(--color7) !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/ChatWindow.vue